import { useState } from "react";
import styles from "./touchSelect.module.css";
import { CardThree } from "../../../components/cards/cardThree";
import { Options } from "../../../components/options/options";
import { toast } from "react-toastify";
import { playSound, toastOptions } from "../../../utilities/utilities";
import { Option } from "../../../components/options/option";

export const TouchSelectOne = ({ previousGamepadLoop, game }) => {
      const [showOptions, setShowOptions] = useState(false);
      const [showBottom, setShowBottom] = useState(true);
      const settingClickHandler = (event) => {
            event.stopPropagation();
            game.sounds.clickSound.play();
            const positions = event.currentTarget.getBoundingClientRect();
            if (positions.top < window.innerHeight / 2) {
                  setShowBottom(true);
            } else {
                  setShowBottom(false);
            }
            setShowOptions(true);
      };

      let assignedButtonName = game.showTouchControls;

      const optionsClickHandler = (event, currentGamePadLoopState) => {
            event.stopPropagation();
            const value = event.target.getAttribute("data-value");

            if (value === "yes") {
                  game.showTouchControls = "yes";
                  game.userSavedData.settings.showTouchControls = "yes";
                  game.saveData();
            } else {
                  game.showTouchControls = "no";
                  game.userSavedData.settings.showTouchControls = "no";
                  game.saveData();
            }
            playSound(game, "click");
            setShowOptions(false);
            currentGamePadLoopState.run = false;
            previousGamepadLoop.gamepadLoopState.run = true;
            previousGamepadLoop.setStartGamePadLoop(true);
      };

      return (
            <div className={styles["setting-container"]}>
                  <span>display</span>
                  <CardThree
                        customClass={styles["setting"]}
                        tabIndex={2}
                        onClick={settingClickHandler}
                  >
                        {assignedButtonName}

                        {showOptions ? (
                              <Options
                                    previousGamepadLoop={previousGamepadLoop}
                                    game={game}
                                    setShowOptions={setShowOptions}
                                    clickHandler={optionsClickHandler}
                                    showBottom={showBottom}
                              >
                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-value": "no",
                                          }}
                                    >
                                          no
                                    </Option>

                                    <Option
                                          attributes={{
                                                tabIndex: 3,
                                                "data-value": "yes",
                                          }}
                                    >
                                          yes
                                    </Option>
                              </Options>
                        ) : null}
                  </CardThree>
            </div>
      );
};
